(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-includes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-includes')) {
    customElements.define('bundle-includes', class BundleIncludes extends HTMLElement {
      connectedCallback() {
        const checkmark = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8L6 12L14 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        this.querySelectorAll('li').forEach(li => {
          li.insertAdjacentHTML('afterbegin', checkmark);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
